import React, { useState, useContext } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Alert, CircularProgress } from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import { SplitAuthLayout, AmberButton, AuthInput } from '../components/design';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, checkSubscription } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(formData);
      const subscriptionStatus = await checkSubscription();
      navigate(subscriptionStatus.isActive ? '/dashboard' : '/checkout');
    } catch (err) {
      setError(err.msg || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  return (
    <SplitAuthLayout statusLine="// welcome back · secure session">
      <Box component="h1" sx={{ m: 0, mb: '6px', fontSize: '24px', fontWeight: 700, color: '#f4f8ff', letterSpacing: '-.01em' }}>
        Log in
      </Box>
      <Box sx={{ mb: '26px', fontSize: '14.5px', color: '#8fa3c6' }}>
        Enter your credentials to continue.
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: '20px', background: 'rgba(244,113,106,.1)', color: '#f4a39e', border: '1px solid rgba(244,113,106,.3)', '& .MuiAlert-icon': { color: '#f4716a' } }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <AuthInput label="Email" id="email" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@company.com" autoComplete="email" autoFocus required />
        <Box>
          <AuthInput label="Password" id="password" type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••••" autoComplete="current-password" required />
          <Box sx={{ textAlign: 'right', mt: '8px' }}>
            <Box
              component={RouterLink}
              to="/forgot-password"
              sx={{ fontSize: '13px', color: '#2dd4bf', textDecoration: 'none', '&:hover': { color: '#5fe6d6' } }}
            >
              Forgot password?
            </Box>
          </Box>
        </Box>

        <AmberButton
          size="lg"
          fullWidth
          sx={{ mt: '6px' }}
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? <CircularProgress size={18} sx={{ color: '#241200' }} /> : 'Log in'}
        </AmberButton>
      </Box>

      <Box sx={{ mt: '22px', textAlign: 'center', fontSize: '13.5px', color: '#8298bd' }}>
        No account?{' '}
        <Box
          component={RouterLink}
          to="/register"
          sx={{ color: '#2dd4bf', textDecoration: 'none', fontWeight: 500, '&:hover': { color: '#5fe6d6' } }}
        >
          Create one
        </Box>
      </Box>
    </SplitAuthLayout>
  );
};

export default Login;
